import React, { useEffect, useState, useContext, useRef } from 'react'
import { ContentInner } from '../../../../../layout/Content'
import ProductsPriceListInnerStyle from './css/ProductsPriceListInnerStyle'
import { appContext } from '../../../../../../App'
import { formatNumber } from '../../../../../utilities/utilities'
import PrinterSettingsStyle from '../../../../../../css/PrinterSettingsStyle'
import { productsPriceListControllerContext } from './ProductsPriceListController'

function ProductsListContents(props) {
  const products = props.products
  const classification = props.classification

  return (
    <React.Fragment>
      <div id='warehouse-inventory-container'>
        <table className='inventory-table'>
          <thead>
            <tr>
              <th style={{textAlign: 'left'}}>Item Name</th>
              <th style={{textAlign: 'left'}}>Unit</th>
              <th>Vatable</th>
              <th style={{textAlign: 'right'}}>Capital</th>
              <th style={{textAlign: 'right'}}>Wholesale</th>
              <th style={{textAlign: 'right'}}>Retail</th>
            </tr>
          </thead>
          {
            products.filter(product => (product.classification === classification)).map(product => (
              product.units.map((unit, index) => (
                <tbody key={index}>
                  <tr>
                    <td style={{textAlign: 'left'}}>{product.brand} {product.name} {product.description}</td>
                    <td>{unit.description}</td>
                    <td style={{textAlign: 'center'}}>{(unit.vatable) ? 'Yes' : 'No'}</td>
                    <td style={{textAlign: 'right'}}>P{formatNumber(unit.capital_amount.toFixed(2))}</td>
                    <td style={{textAlign: 'right'}}>P{formatNumber(unit.wholesale_price.toFixed(2))}</td>
                    <td style={{textAlign: 'right'}}>P{formatNumber(unit.retail_price.toFixed(2))}</td>
                  </tr>
                </tbody>
              ))
            ))
          }
        </table>
      </div>
    </React.Fragment>
  )
}

function useProductsPriceList(props) {
  const app = useContext(appContext)
  const productsPriceListController = useContext(productsPriceListControllerContext)
  const { filter, getWarehouses, getProductsList } = productsPriceListController
  const [productsInventory, setProductsInventory] = useState(null)
  let warehouseFilter = useRef([])
  let classificationFilter = useRef([])

  useEffect(() => {
    const initProductsInventory = async (warehouses) => {
      const prodInv = []

      for (let warehouse of warehouses) {
        // Filter the warehouse
        if (warehouseFilter.current.find(wh => (wh === warehouse.name))) {
          let products = await getProductsList(app, warehouse._id)

          // Filter the products
          products = products.filter(product => (
              classificationFilter.current.find(classification => (classification === product.classification))
            )
          )

          prodInv.push (
            {
              wh: warehouse,
              products: products
            }
          )
        }
      }

      setProductsInventory(prodInv)
    }

    const init = async () => {
      // Warehouse filter
      for (let key in filter.warehouse) {
        if (filter.warehouse[key]) {
          //push into temp array here
          warehouseFilter.current.push(key)
        }
      }

      // Classification filter
      for (let key in filter.classification) {
        if (filter.classification[key]) {
          classificationFilter.current.push(key)
        }
      }

      initProductsInventory(await getWarehouses(app))
    }

    init()
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return ({
    app,
    productsInventory: [productsInventory, setProductsInventory],
    classifications: classificationFilter.current
  })
}

function ProductsPriceListInner(props) {
  const productsPriceList = useProductsPriceList(props)
  const { app } = productsPriceList
  const prodInv = productsPriceList.productsInventory[0]
  const classifications = productsPriceList.classifications

  return (
    <ContentInner>
      <div className='report-wrapper'>
        <div id='products-list-container' className='printable'>
          {
            (prodInv) ?
              prodInv.map((pi, i) => (
                <div key={i} className={ (i === 0) ? 'firstpage' : 'pagebreak' }>
                  <div className='products-inventory-header-container'>
                    <div className='products-inventory-header'>Products Price List</div>
                    <div className='products-inventory-date'>As of {new Date(app.getClientDateTime()).toLocaleString("en-us")} { app.getClientTimezone() }</div>
                  </div>
                  <br />
                  <div className='warehouse-name'><span style={{fontWeight: 'bold'}}>Warehouse:</span> {pi.wh.name} </div>
                  <hr />
                  {
                    classifications.map((classification, index) => (
                      <div key={index}>
                        <div><b>Classification:</b> {classification}</div>
                        <div className='products-list-contents-wrapper'>
                          <ProductsListContents products={pi.products} classification={classification}/>
                        </div>
                      </div>
                    ))
                  }
                </div>
              ))
            : null
          }
        </div>
      </div>
      <ProductsPriceListInnerStyle />
      <PrinterSettingsStyle paperWidth='8.5inch'/>
    </ContentInner>
  )
}

export default React.memo(ProductsPriceListInner)